module.exports = __webpack_public_path__ + "img/food_19.8e7e344c.jpg";